import React, { useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Container, Button, Row, Col } from "reactstrap";
import classNames from "classnames";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import { withRouter } from 'react-router-dom'

import HolidayBanner from "../../images/holiday-raffle-banner.png";
import GoodDayBanner from "../../images/goodday-raffle-banner.png";
import InfoIcon from '../../images/info-button.png';

import {
  getRaffleList,
  getClosedRaffleList,
  getRafflesToday,
  getUserRaffleTickets,
  getProductRaffleCount,
  postRaffleEntry,
  getRaffleGroup,
  getRaffleBanner,
  getProductRaffleEntry
} from "../../actions/kafairAction";

import {
  getDetailSection
} from "../../actions/productAction"

import { Banner, Content } from "../Assets";
import CardLoading from "../../components/Loading/CardLoading";
import FilterAndSort from "../../components/PageSearchDetails/FilterAndSort";
import { isFromAppBrowser, getCloudImageUrl } from "../../utils/Helpers";
import SneakerImage from "../../components/Sneakers/SneakerImage";
import { TextRupiah } from "../../components/Text";
import { ModalRaffleAlert, ModalLoginNew } from "../../components/Modals";
import styled from "styled-components";
import { ASSET_IMAGE } from "../../config";

// Image
import RaffleSuccess from "../../images/raffle-success.png"
import RaffleFailed from "../../images/raffle-failed.png"

// Helpers
import { convertHexToRGBA } from "../../helpers/color"
import { doFetchCurrencyRate, doFetchProfile } from "../../actions/authAction";
import { CURRENCY_CODE } from "../../constants";
import { joinClassnames } from "helpers/classNames";

const goldenTicket = require("../../images/golden-ticket.png");
const standardTicket = require("../../images/standard-ticket.png");
const GRANDPRIZE_IMAGE = require("../../images/grandprizeIcon.png");

const banner = {
  // golden: require("../../images/novembazar_raffle_gold.png"),
  // standard: require("../../images/novembazar_raffle_standard.png"),
  golden: `${ASSET_IMAGE}/banner/harbolnas/gold_raffle_web.png`,
  standard: `${ASSET_IMAGE}/banner/harbolnas/green_raffle_web.png`,
  purple: require("../../images/webbanner_flavorzone.jpg"),
};

// const renderer = ({ days, hours, minutes, seconds, completed }) => {
//   if (completed) {
//     return (
//       <div>
//         <span>
//           {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
//           {zeroPad(seconds)}
//         </span>
//       </div>
//     );
//   } else {
//     return (
//       <div className="countdown-wrapper">
//         <span>
//           {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
//           {zeroPad(seconds)}
//         </span>
//       </div>
//     );
//   }
// };

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (days !== 0) {
    return (
      <p>
        Ends In <span>{days}</span> days <span>{hours}</span> hours
      </p>
    );
  } else if (hours !== 0) {
    return (
      <p>
        Ends In <span>{hours}</span> hours <span>{minutes}</span> minutes
      </p>
    );
  } else {
    return (
      <p>
        Ends In <span>{minutes}</span> minutes {seconds} seconds
      </p>
    );
  }
};

const ProductItem = ({
  item,
  getProductRaffleCount,
  redeemCount,
  changeCounter,
  ticket_type,
  color,
  counterRefreshed,
  isActive,
  isChildrenProduct,
  showError,
  hasStarted,
  fullWidth,
  totalEntries,
  getProductRaffleEntry
}) => {
  const [counter, setCounter] = useState(0);
  const [raffleCount, setRaffleCount] = useState(redeemCount);
  const [raffleEntry, setRaffleEntry] = useState(0);

  useEffect(() => getRaffleCount(item.id), [
    item.id,
    redeemCount,
    counterRefreshed,
  ]);
  useEffect(() => getRaffleEntry(item.id), [
    item.id,
    redeemCount,
    counterRefreshed,
  ]);
  function getRaffleCount(id) {
    if (getProductRaffleCount) {
      setCounter(0);
      getProductRaffleCount(id, ticket_type);
    }
  }
  function getRaffleEntry(id) {
    if (getProductRaffleEntry) {
      setCounter(0);
      getProductRaffleEntry(id, ticket_type)
        .then((res) => {
          const raffleEntry = res.value.data[ticket_type].total_entry
          setRaffleEntry(raffleEntry);
        })
        .catch((err) => {
          console.log('error raffle entry', err)
        });
    }
  }
  function countUp() {
    const nextCounter = counter + 1;
    const nextRaffleCounter = raffleCount + 1;
    changeCounter(item.id, nextCounter)
      .then((res) => {
        setCounter(nextCounter);
        setRaffleCount(nextRaffleCounter);
      })
      .catch((err) => {
        setCounter(counter);
        setRaffleCount(raffleCount);
        showError(err);
      });
  }
  function countDown() {
    if (counter === 0) return;
    const nextCounter = counter - 1;
    const nextRaffleCounter = raffleCount - 1;
    changeCounter(item.id, nextCounter)
      .then((res) => {
        setCounter(nextCounter);
        setRaffleCount(nextRaffleCounter);
      })
      .catch((err) => {
        showError(err);
      });
  }

  function onChangeCounter(e) {
    const val = e.target.value;
    changeCounter(item.id, val ? parseInt(val) : 0, true)
      .then((res) => {
        setCounter(val ? parseInt(val) : "");
        const nextRaffleCounter = raffleCount + parseInt(val);
        setRaffleCount(nextRaffleCounter);
      })
      .catch((err) => {
        setCounter(val);
        showError(err);
      });
  }
  function onBlur() {
    if (!counter) {
      setCounter(0);
    }
  }

  return (
    <Col
      xs={isChildrenProduct && fullWidth ? 12 : 6}
      md={isChildrenProduct && fullWidth ? 12 : 3}
    >
      <div
        className={classNames("product-card", {
          active: isActive,
          // "full-width": isChildrenProduct && fullWidth
        })}
      >
        {/* <span className="productTitle">
          {item.brand ? item.brand.flat.length > 0 && item.brand.flat[0] : ""}
        </span> */}
        {/* <span className="productTitle">{item.display_name}</span> */}
        {!!redeemCount && hasStarted && (
          <div
            className={classNames("product-count")}
            style={{
              backgroundColor: color,
              color: "#FFF",
            }}
          >
            <p>x {redeemCount}</p>
          </div>
        )}
        <SneakerImage
          hasImage={item.image ? true : false}
          src={item.image ? getCloudImageUrl(item.image, 400) : null}
          alt={item.display_name}
        />
        <div className="product-title-container">
          <span className="productTitle">{item.display_name}</span>
        </div>
        <TextRupiah
          value={item.price}
          className="price-tag"
          color="black"
          bold={true}
          align="center"
        />
        {isActive && (
          <div className="counter-wrapper">
            <span className="counter-control" onClick={countDown}>
              -
            </span>
            <input
              className={classNames("counter-input", {
                // "full-width": isChildrenProduct && fullWidth
              })}
              value={counter}
              onBlur={onBlur}
              pattern="[0-9]*"
              onChange={onChangeCounter}
            ></input>
            <span className="counter-control" onClick={countUp}>
              +
            </span>
          </div>
        )}
        <p>{raffleEntry}{raffleEntry === 0 ? null : "+"} Entries</p>
      </div>
    </Col>
  );
};

class RaffleDetailNovembazar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      showModalLogin: false,
      isLoggedIn: false,
      showModalInfo: false,
      isGolden: false,
      messageInfo: "",
      titleMessageInfo: "",
      selectedProduct: [],
      rest_ticket: 0,
      counterRefreshed: 0,
      isSubmitting: false,
      ticket_type: false,
      group_name: null,
      selectedRaffleGroup: {},
      raffleGroupDetail: {},
      children_group: null,
      holidayBanner:
        "https://kickavenue-assets.s3.amazonaws.com/banner/event/event-holiday-raffle.png",
      goodDayBanner:
        "https://kickavenue-assets.s3.amazonaws.com/banner/event/event-goodday-raffle.png",
      greenBanner:
        "https://kickavenue-assets.s3.amazonaws.com/banner/event/web-event-goodday-raffle.png",
      raffleBanner: [],
    };
  }

  componentDidMount() {
    this.props.getRaffleGroup();
    if (window.Intercom) {
      window.Intercom("update", {
        hide_default_launcher: true,
      });
    }
    this.props.getUserRaffleTickets();
    this.unAuthHandler();

    const slug = this.props.location.pathname
      && this.props.location.pathname.split('/')[3]
      && this.props.location.pathname.split('/')[3].split("+").join("-")

    const { dataCategory } = this.props

    this.props
      .getDetailSection(dataCategory, slug)
      .then(({ value }) => {
        const { data } = value || {};
        this.setState({
          raffleBanner: data.images,
        });
      })
      .catch(e => console.log(e))
  }

  unAuthHandler = () => {
    const { dataAuth } = this.props;

    if (!dataAuth.isLogged) {
      this.setState({
        showModalLogin: true,
      });
    }
  };

  componentWillUnmount() {
    if (window.Intercom) {
      window.Intercom("update", {
        hide_default_launcher: false,
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      sliderImages,
      raffleGroup: { data: raffleGroupData },
      dataAuth,
      history
    } = this.props;
    const group_name = this.props.match.params.slug.replace(/\-/gi, "+");

    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      const selectedRaffleGroup = raffleGroupData
        ? raffleGroupData.find((rg) => rg.query === group_name) || {}
        : {};

      this.setState({ group_name, selectedRaffleGroup });
    }

    if ((prevProps.dataAuth.userdata.isFetch !== dataAuth.userdata.isFetch) && (prevProps.dataAuth.userdata.isFetch && !dataAuth.userdata.isFetch)) {
      this.setState({
        isLoggedIn: dataAuth.isLogged,
      });

      if (!dataAuth.isLogged) {
        this.setState({
          showModalLogin: true,
        });
      } else if (dataAuth.isLogged) {
        this.fetchAll();
      }
    }

    if (
      !dataAuth.signIn.isSubmit &&
      prevProps.dataAuth.signIn.isSubmit !== dataAuth.signIn.isSubmit
    ) {
      const { error, isSubmit } = dataAuth.signIn;
      const { dataCategory } = this.props;
      if (!error) {
        await this.setState({
          showModalLogin: false,
          isLoggedIn: true,
        });
      } else {
        await this.setState({
          showModalLogin: true,
          isLoggedIn: false,
        });
      }
    }

    if (prevState.showModalLogin !== this.state.showModalLogin) {
      const { error, isSubmit } = dataAuth.signIn;

      if (this.state.showModalLogin && !this.state.isLoggedIn && !isSubmit) {
        this.props.history.push({
          pathname: "/login",
          state: {
            isFromRafflePage: true,
            redirectPath: this.props.history.location.pathname,
          }
        });
      }
    }

    if (
      prevProps.redeemRaffle.isFetching &&
      !this.props.redeemRaffle.isFetching
    ) {
      if (!this.props.redeemRaffle.error) {
        const amountOfTicket = this.props.redeemRaffle.redeemedTicket;
        this.setState((prevState) => ({
          selectedProduct: [],
          counterRefreshed: prevState.counterRefreshed + 1,
          showModalInfo: true,
          titleMessageInfo: "Successfully Submitted!",
          messageInfo: `We have received your submission of ${amountOfTicket} ticket(s). You can keep submitting tickets before the event ends. 
          The winner will be announced through our instagram account and approached by our customer service. \n Good Luck!`,
        }));

        this.getProductList();
        this.props.getUserRaffleTickets();
      } else {
        this.setState((prevState) => ({
          selectedProduct: [],
          counterRefreshed: prevState.counterRefreshed + 1,
          showModalInfo: true,
          titleMessageInfo: "There was an error submitting your ticket",
          messageInfo:
            this.props.redeemRaffle.error.message ||
            `Your ticket was unable to be submitted. \n Please Try Again!`,
        }));
      }
    }
    if (
      prevProps.raffleGroup.isFetching &&
      !this.props.raffleGroup.isFetching
    ) {
      if (!this.props.raffleGroup.error) {
        this.setInitialGroupName();
      } else {
        this.setState({
          showModalInfo: true,
          messageInfo:
            this.props.raffleGroup.error.message ||
            "Sorry, something wrong! Try again later",
        });
      }
    }
    if (prevState.group_name !== this.state.group_name) {
      this.fetchAll();
    }
    if (prevProps.location !== this.props.location) {
      this.props.getRaffleGroup();
      if (window.Intercom) {
        window.Intercom("update", {
          hide_default_launcher: true,
        });
      }
      this.props.getUserRaffleTickets();
      this.unAuthHandler();

      const slug = this.props.location.pathname
        && this.props.location.pathname.split('/')[3]
        && this.props.location.pathname.split('/')[3].split("+").join("-")

      const { dataCategory } = this.props

      this.props
        .getDetailSection(dataCategory, slug)
        .then(({ value }) => {
          const { data } = value || {};
          this.setState({
            raffleBanner: data.images,
          });
        })
        .catch(e => console.log(e))
    }
  }

  setInitialGroupName = () => {
    const {
      raffleGroup: { data: raffleGroupData },
    } = this.props;
    const group_name = this.props.match.params.slug.replace(/\-/gi, "+");

    const selectedRaffleGroup = raffleGroupData
      ? raffleGroupData.find((rg) => rg.query === group_name) || {}
      : {};

    this.setState({ selectedRaffleGroup, group_name });
  };

  fetchAll = () => {
    const { fetchProfile } = this.props;
    const { group_name } = this.state;

    this.props.getRafflesToday(group_name);
    this.props.getUserRaffleTickets();
    this.getProductList();
    if (this.props.dataAuth.userdata.country_code) {
      const { country_code } = this.props.dataAuth.userdata;
      const currencyCode = CURRENCY_CODE[country_code === 'IDN' ? 'IDN' : 'ETC'];
      this.props.getCurrencyRate(currencyCode);
    } else if (!this.props.dataAuth.userdata.country_code && !this.props.dataAuth.userdata.isFetch) {
      fetchProfile().then(res => {
        const { country_code } = res.value.data;
        const currencyCode = CURRENCY_CODE[country_code === 'IDN' ? 'IDN' : 'ETC'];
        this.props.getCurrencyRate(currencyCode);
      })
    }
  };

  getProductList = (page = 1) => {
    const { group_name } = this.state;

    if (!group_name) return;

    const {
      started_at,
      raffleGroup: { data: raffleGroupData },
    } = this.props;
    const startDate = moment(started_at).format("YYYYMMDD");
    const today = moment().format("YYYYMMDD");
    const hasStarted = moment(today).isAfter(startDate);

    const selectedRaffleGroup = raffleGroupData
      ? raffleGroupData.find((rg) => rg.query === group_name)
      : {};
    const children =
      selectedRaffleGroup &&
        selectedRaffleGroup.children &&
        selectedRaffleGroup.children.length
        ? selectedRaffleGroup.children[0]
        : null;

    if (children) {
      this.setState({ children_group: children });
      this.props.getRafflesToday(children.query);
    } else {
      this.setState({ children_group: null });
    }

    const date = hasStarted || !started_at ? today : startDate;

    this.props.getRaffleList(group_name, date, page).then(res => {
      const group_detail = res.value?.data?.raffle?.raffle_group || null
      if (group_detail) {
        this.setState({
          raffleGroupDetail: group_detail
        })
      }
    });
    this.props.getClosedRaffleList(group_name);
  };

  onCloseModal = () => {
    const { dataAuth } = this.props;

    this.setState({
      showModalLogin: false,
    });
  };

  toggleModalInfo = () => {
    const { selectedProduct, selectedRaffleGroup } = this.state;
    const restTicket = this.hasSufficientTicket(selectedProduct);

    try {
      const group_name = this.props.match.params.slug.replace(/\-/gi, " ");

      this.setState({
        showModalInfo: !this.state.showModalInfo,
        messageInfo: `Anda memiliki ${restTicket} tiket untuk mengikuti ${selectedRaffleGroup.title}`,
      });
    } catch (e) {
      console.log("error toggle modal info: ", e);
    }
  };

  showError = (message) => {
    this.setState({
      showModalInfo: true,
      messageInfo: message,
      titleMessageInfo: "There was an error submitting your ticket",
    });
  };

  changeCounter = (itemId, val, isOnChange = false) => {
    const {
      userRaffleTicket = {}
    } = this.props;
    const {
      selectedRaffleGroup
    } = this.state
    const userTikets = userRaffleTicket.data || {}

    let text = (
      selectedRaffleGroup?.ticket_type === "blue" ?
        "products with BCA Payment method"
        : selectedRaffleGroup?.ticket_type === "green" ?
          ""
          : selectedRaffleGroup?.ticket_type === "orange" ?
            "Raffle by Kalibre"
            : ""
    )
    return new Promise((resolve, reject) => {
      const { selectedProduct } = this.state;

      if (!this.isProductAlreadySelected(itemId)) {
        const nextSelectedProduct = [
          ...selectedProduct,
          {
            raffle_id: itemId,
            quantity: val,
          },
        ];

        const rest_ticket = this.hasSufficientTicket(nextSelectedProduct);
        if (rest_ticket >= 0) {
          resolve(
            this.setState({
              selectedProduct: nextSelectedProduct,
              rest_ticket,
            })
          );
        } else
          reject(
            `You don’t have enough tickets. \n Get tickets from purchasing any ${text} products available on our marketplace.`
          );
      } else {
        const nextSelectedProduct = selectedProduct.map((p) => {
          if (p.raffle_id === itemId) {
            p.quantity = val;
          }

          return p;
        });

        if (this.hasSufficientTicket(nextSelectedProduct) >= 0) {
          resolve(
            this.setState({
              selectedProduct: nextSelectedProduct,
            })
          );
        } else {
          const nextSelectedProduct = selectedProduct.map((p) => {
            if (p.raffle_id === itemId) {
              p.quantity = isOnChange ? val : val - 1;
            }

            return p;
          });
          reject(
            `You don’t have enough tickets. \n Get tickets from purchasing any ${text} products available on our marketplace.`
          );
        }
      }
    });
  };

  hasSufficientTicket(nextSelectedProduct) {
    const { selectedRaffleGroup } = this.state;
    const { userRaffleTicket } = this.props;
    const user_ticket =
      userRaffleTicket &&
        userRaffleTicket.data &&
        userRaffleTicket.data[selectedRaffleGroup.ticket_type]
        ? userRaffleTicket.data[selectedRaffleGroup.ticket_type].total
        : 0;

    const sumOfTicket = nextSelectedProduct.reduce(
      (total, currentVal) => total + parseInt(currentVal.quantity),
      0
    );
    const restTicket = user_ticket - sumOfTicket;

    return restTicket;
  }

  isProductAlreadySelected = (itemId) => {
    const { selectedProduct } = this.state;
    return selectedProduct.find((p) => p.raffle_id == itemId);
  };

  setActiveGroup = (selectedRaffleGroup) => {
    const { dataCategory } = this.props;

    this.setState(
      {
        group_name: selectedRaffleGroup.query,
        selectedRaffleGroup,
      },
      () =>
        this.props.history.push(
          `/${dataCategory}/raffle/${selectedRaffleGroup.query}`
        )
    );
  };

  renderButtonGroups = () => {
    const {
      raffleGroup: { data: raffleGroupData },
      userRaffleTicket,
    } = this.props;
    const { selectedRaffleGroup, group_name } = this.state;

    if (!raffleGroupData || raffleGroupData.length === 0) return null;

    return (
      <div className="raffle-group-button-wrapper">
        {raffleGroupData.map((rg) => {
          const isSelected = group_name === rg.query;
          const color =
            userRaffleTicket &&
              userRaffleTicket.data &&
              rg &&
              userRaffleTicket.data[rg.ticket_type]
              ? userRaffleTicket.data[rg.ticket_type].color
              : "#fff";
          const button_bg =
            userRaffleTicket &&
              userRaffleTicket.data &&
              rg &&
              userRaffleTicket.data[rg.ticket_type]
              ? userRaffleTicket.data[rg.ticket_type].btn_img_url
              : "#fff";

          return (
            <div
              className={classNames("raffle-group-button", {
                isSelected: isSelected,
              })}
              onClick={(e) => {
                e.preventDefault();
                this.setActiveGroup(rg);
              }}
              style={
                !isSelected
                  ? { backgroundColor: rg.color, opacity: 0.3 }
                  : { backgroundColor: rg.color }
              }
            >
              {/* {isSelected && <KickImage src={button_bg} />} */}
              <span>{rg.ticket_name}</span>
            </div>
          );
        })}
      </div>
    );
  };

  renderChildrenList = () => {
    const {
      children_group,
      counterRefreshed,
      selectedProduct,
      selectedRaffleGroup,
      ticket_type,
    } = this.state;
    const { raffle, userRaffleTicket, raffleProduct, totalEntry } = this.props;
    const section = raffle[children_group && children_group.query];

    if (!children_group || !section) return null;

    const products = section.products || [];
    const isStart = moment().isAfter(section.start_date);
    const isExpired = moment().isAfter(section.expiry);
    const { currency, ratio, getProductRaffleCount } = this.props;
    const restTicket = this.hasSufficientTicket(selectedProduct);

    const ticket_bg =
      userRaffleTicket &&
      userRaffleTicket.data &&
      userRaffleTicket.data[children_group.ticket_type] &&
      userRaffleTicket.data[children_group.ticket_type].ticket_img_url;
    const redeem_count_bg =
      userRaffleTicket &&
      userRaffleTicket.data &&
      userRaffleTicket.data[selectedRaffleGroup.ticket_type] &&
      userRaffleTicket.data[selectedRaffleGroup.ticket_type].badge_img_url;

    return (
      <div className="raffle-group">
        <Container>
          <Row className="product-wrapper">
            {products.length > 0
              ? products.map((item, index) => {
                const redeemCount = raffleProduct
                  ? raffleProduct[item.id]
                  : 0;
                const totalEntries = totalEntry ? totalEntry[item.id] : 0;
                return (
                  <ProductItem
                    item={item}
                    getProductRaffleCount={this.props.getProductRaffleCount}
                    redeemCount={redeemCount}
                    changeCounter={this.changeCounter}
                    counterRefreshed={counterRefreshed}
                    ticket_type={selectedRaffleGroup.ticket_type}
                    color={selectedRaffleGroup.color}
                    isActive={isStart}
                    showError={this.showError}
                    isChildrenProduct
                    fullWidth
                    hasStarted={isStart}
                    totalEntries={totalEntries}
                    getProductRaffleEntry={this.props.getProductRaffleEntry}
                  />
                );
              })
              : null}
          </Row>
        </Container>
      </div>
    );
  };

  renderRaffleList = () => {
    const { group_name } = this.state;
    if (!group_name) return null;

    const {
      selectedProduct,
      selectedRaffleGroup,
      counterRefreshed,
      isGolden,
      isLoading,
    } = this.state;
    const {
      raffleList,
      currency,
      ratio,
      getProductRaffleCount,
      dataAuth,
      raffleProduct,
      totalEntry,
    } = this.props;
    let infoShown = 0;

    if (!dataAuth.isLogged) return null;

    const list =
      (raffleList &&
        raffleList[group_name] &&
        raffleList[group_name].active &&
        raffleList[group_name].active.list) ||
      {};

    if (isLoading && Object.keys(list).length === 0)
      return (
        <div
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            marginTop: 30,
          }}
        >
          Loading..
        </div>
      );

    const restTicket = this.hasSufficientTicket(selectedProduct);
    return Object.keys(list).map((date, index) => {
      const section = list[date];
      const { products } = section;
      const isStart = moment().isAfter(section.start);
      const isExpired = moment().isAfter(section.expiry);

      if (isStart) infoShown++;

      return (
        <div key={index} className="raffle-group">
          <Container>
            <Row className="product-wrapper">
              {products.length > 0
                ? products.map((item, index) => {
                  const redeemCount = raffleProduct
                    ? raffleProduct[item.id]
                    : 0;
                  const totalEntries = totalEntry ? totalEntry[item.id] : 0;

                  return (
                    <ProductItem
                      item={item}
                      getProductRaffleCount={this.props.getProductRaffleCount}
                      redeemCount={redeemCount}
                      changeCounter={this.changeCounter}
                      ticket_type={selectedRaffleGroup.ticket_type}
                      color={selectedRaffleGroup.color}
                      counterRefreshed={counterRefreshed}
                      isActive={isStart}
                      hasStarted={isStart}
                      isChildrenProduct={selectedRaffleGroup.grand_prize}
                      fullWidth={products.length === 1}
                      showError={this.showError}
                      totalEntries={totalEntries}
                      getProductRaffleEntry={this.props.getProductRaffleEntry}
                    />
                  );
                })
                : null}
            </Row>
          </Container>
        </div>
      );
    });
  };

  renderClosedRaffleList = () => {
    const group_name = this.props.match.params.slug.replace(/\-/gi, "+");
    const {
      selectedProduct,
      selectedRaffleGroup,
      counterRefreshed,
      isGolden,
      isLoading,
    } = this.state;
    const {
      raffleList,
      currency,
      ratio,
      getProductRaffleCount,
      dataAuth,
      raffleProduct,
    } = this.props;
    let infoShown = 0;

    if (!dataAuth.isLogged) return null;

    const products =
      raffleList && raffleList[group_name]
        ? raffleList[group_name].closed || []
        : [];

    if (products.length === 0) return null;

    return (
      <div className="raffle-group">
        <div className="title-wrapper">
          <span className="group-title">SUDAH BERAKHIR</span>
        </div>

        <Container>
          <Row className="product-wrapper">
            {products.length > 0
              ? products.map((item, index) => {
                const redeemCount = raffleProduct
                  ? raffleProduct[item.id]
                  : 0;
                return (
                  <ProductItem
                    item={item}
                    getProductRaffleCount={this.props.getProductRaffleCount}
                    redeemCount={redeemCount}
                    changeCounter={this.changeCounter}
                    ticket_type={selectedRaffleGroup.ticket_type}
                    color={selectedRaffleGroup.color}
                    hasStarted={true}
                    showError={this.showError}
                    getProductRaffleEntry={this.props.getProductRaffleEntry}
                  />
                );
              })
              : null}
          </Row>
        </Container>
      </div>
    );
  };

  doSubmitRedeem = () => {
    const { selectedProduct } = this.state;
    this.props.postRaffleEntry(selectedProduct);
  };

  goToTOS = () => {
    const { selectedRaffleGroup } = this.state;
    // const group_name = selectedRaffleGroup.query;
    const title = selectedRaffleGroup?.title || 'Green Raffle'
    // const keyword = title?.toLowerCase().replace(' ', '-')
    const keyword = title?.toLowerCase()?.split(" ")?.join("-")

    this.props.history.push(`/helps/${keyword}`);
  };

  //Redner Title
  renderTitle(raffleTitle, raffleColor) {
    if (!raffleTitle) {
      return <p className="raffle-leftText"></p>
    }

    if (typeof raffleTitle !== 'string') {
      return <p className="raffle-leftText"></p>
    }

    const splitedTitle = raffleTitle.split(" ")
    if (splitedTitle.length === 0 || !splitedTitle) {
      return <p className="raffle-leftText"></p>
    }

    const blackColoredTitle = splitedTitle.filter((_, idx) => idx > 0)
    let blackColoredTitleString = ''
    if (blackColoredTitle.length > 0) {
      blackColoredTitleString = blackColoredTitle.join(" ")
    }

    return <p className="raffle-leftText" style={{ color: "#242424" }}><span style={{ color: raffleColor ? raffleColor : "#242424", }}>{splitedTitle[0]}</span> {blackColoredTitleString}</p>
  }

  //Redner Title
  renderAllRaffleTab() {
    const {
      raffleGroup: { data: raffleGroupData = [] } = {},
      userRaffleTicket = {}
    } = this.props;
    const {
      selectedRaffleGroup
    } = this.state
    const userTikets = userRaffleTicket.data || {}
    if (!raffleGroupData || raffleGroupData?.length === 0) {
      return <div className="raffle-tab-wrapper"></div>
    }
    return (
      <div className="raffle-tab-container">
        <div className="raffle-tab-wrapper">
          {
            raffleGroupData?.map(raffle => {
              const {
                ticket_type
              } = raffle || {}
              const isSelectedGrup = selectedRaffleGroup?.ticket_type === raffle?.ticket_type ? true : false
              let currentTicket = {}
              let style = {
                backgroundColor: convertHexToRGBA(raffle?.color, 0.1)
              }

              let textStyle = {
                color: raffle.color
              }

              if (isSelectedGrup) {
                style["backgroundColor"] = raffle?.color
                textStyle["color"] = "#fff"
              }
              if (!userTikets[ticket_type]?.active) {
                return null
              }
              if (userTikets[ticket_type]) {
                currentTicket = userTikets[ticket_type]?.ticket_img_url
              }
              return <div
                onClick={() => {
                  this.props.history.push(`/${"sneakers"}/raffle/${raffle.query}`)
                  // window.location.reload(true);
                }}
                style={style}
                className="raffle-tab-nav">
                <p style={textStyle}>{raffle.title}</p>
                <div className={`${isSelectedGrup ? "selected-underline" : ""}`} />
              </div>
            })
          }
        </div>
      </div>
    )
  }


  render() {
    const { userRaffleTicket, raffle, raffleGroup, raffleProduct, countdown_modal } = this.props;
    const {
      group_name,
      selectedProduct,
      selectedRaffleGroup,
      titleMessageInfo,
      messageInfo,
      raffleBanner,
      raffleGroupDetail
    } = this.state;

    const imageBanner = banner[selectedRaffleGroup.ticket_type];

    const raffle_ticket_bg =
      userRaffleTicket.data &&
        userRaffleTicket.data[selectedRaffleGroup.ticket_type]
        ? userRaffleTicket.data[selectedRaffleGroup.ticket_type].ticket_img_url
        : null;

    const real_user_ticket =
      userRaffleTicket &&
        userRaffleTicket.data &&
        userRaffleTicket.data[selectedRaffleGroup.ticket_type]
        ? userRaffleTicket.data[selectedRaffleGroup.ticket_type].total
        : 0;

    const user_ticket = this.hasSufficientTicket(selectedProduct);

    const sumOfTicket = selectedProduct.reduce(
      (total, currentVal) => total + parseInt(currentVal.quantity),
      0
    );

    const readyToRedeem =
      selectedProduct.length > 0 && selectedProduct.find((s) => s.quantity > 0);

    const isTicketEnough = sumOfTicket <= real_user_ticket;

    const dataRaffle = raffleGroup.data.find(
      (item) => item.query === group_name
    );

    const sectionTitle = dataRaffle
      ? dataRaffle.title.toUpperCase()
      : group_name
        ? group_name.toUpperCase().replace(/\+/gi, " ")
        : "";

    const desc = raffle && raffle[group_name] && raffle[group_name].description;

    const imgAlert = titleMessageInfo.includes("Success")
      ? RaffleSuccess
      : RaffleFailed;

    const raffles =
      raffleGroup.data &&
        Array.isArray(raffleGroup.data) &&
        raffleGroup.data.length > 0
        ? raffleGroup.data.map((rg) => {
          return {
            ...raffle[rg.query],
            ticket_name: rg.ticket_name,
            ticket_type: rg.ticket_type,
            key: rg.key,
            title: rg.title,
            color: userRaffleTicket?.data?.[selectedRaffleGroup.ticket_type]?.color,
            children: rg.children,
          };
        })
        : [];
    const expiry_date =
      raffles &&
      Array.isArray(raffles) &&
      raffles.length > 0 &&
      raffles[0].expiry;

    const title =
      raffles &&
      Array.isArray(raffles) &&
      raffles.length > 0 &&
      raffles[0].title;

    const imageBannerReady = (() => {
      if (raffleBanner.length > 0)
        return window.screen.availWidth > 480
          ? raffleBanner?.[0]?.URL
          : raffleBanner?.[1]?.URL;
      return "";
    })();

    const landscapeBanner = raffleBanner && raffleBanner.length > 0 ? raffleBanner && raffleBanner.find((i) => i.orientation === "landscape") : null;

    const portraitBanner = raffleBanner && raffleBanner.length > 0 ? raffleBanner && raffleBanner.find((i) => i.orientation === "portrait") : null;

    const raffleColor = userRaffleTicket?.data?.[selectedRaffleGroup.ticket_type]?.color;

    return (
      <Container fluid className={joinClassnames(
        "main-container",
        countdown_modal ? 'countdown-active' : ''
      )} id="home-container">
        <ModalRaffleAlert
          isOpen={this.state.showModalInfo}
          showButton={false}
          onToggle={this.toggleModalInfo}
        >
          <ModalWrapper>
            <KickImage src={imgAlert} />
            <span className="bold">{titleMessageInfo}</span>
            <span>{messageInfo}</span>
          </ModalWrapper>
        </ModalRaffleAlert>

        {
          (landscapeBanner?.URL || portraitBanner?.URL) && (
            <div className="banner-wrapper">
              <div className="banner-container d-none d-sm-block">
                <KickImage src={landscapeBanner && landscapeBanner.URL} noCompress />
              </div>

              <div className="banner-container d-block d-sm-none">
                <KickImage src={portraitBanner && portraitBanner.URL} noCompress />
              </div>
            </div>
          )
        }
        {this.renderAllRaffleTab()}
        <div className="raffle-container" style={{ backgroundColor: "#fff" }}>
          <div className="raffle-group">
            <Container className="raffle-header-wrapper">
              {/* {expiry_date && (
                <Col className="raffle-detail-timer-container">
                  <Countdown
                    date={expiry_date && moment(expiry_date).format()}
                    renderer={renderer}
                    daysInHours={true}
                  />
                  <p>
                    Get raffle tickets from every purchase you made. Applicable
                    on ALL products in the marketplace.
                  </p>
                  <div
                    className="information-btn-wrapper"
                    onClick={() => {
                      window.open("/helps/bcaxkickavenue", "_blank").focus();
                      // this.props.history.push("/helps/bcaxkickavenue")
                    }}
                  >
                    <p>
                      Exclusive for <span>BCA Payment</span>
                    </p>
                    <div className="i-icon-wrapper">
                      <span>i</span>
                    </div>
                  </div>
                </Col>
              )} */}
              <div
                className="header-and-timer-wrapper"
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    window.screen.availWidth <= 480 ? "1fr 1fr" : "1fr 1fr",
                  justifyContent: "center",
                  alignItems: "end",
                  width: "100%",
                }}
              >
                <div className="raffle-leftHeader">
                  {/* <p
                    className="raffle-leftText"
                    style={{
                      color: raffleColor ? raffleColor : "#242424",
                    }}
                  >
                    {sectionTitle ? `${sectionTitle}` : ""}
                  </p> */}
                  {this.renderTitle(sectionTitle, raffleColor)}
                  <div className="mt-3">
                    <p className="raffle-leftDesc">{
                      raffleGroupDetail?.description ? (
                        <div dangerouslySetInnerHTML={{
                          __html: raffleGroupDetail.description
                        }}></div>
                      ) :
                        'Get Tickets From Every Transaction'}</p>
                    <p onClick={() => this.goToTOS()} className="raffle-leftFaq">
                      How to get raffle tickets?
                      <KickImage className="ml-1 mb-1" width="12" src={InfoIcon} />
                    </p>
                  </div>
                </div>
                <TicketWrapper
                  bgColor={dataRaffle && raffleColor && convertHexToRGBA(raffleColor, 0.1)}
                  ticket_type={dataRaffle && dataRaffle.ticket_type}
                >
                  <span
                    style={{ fontSize: "12px", color: dataRaffle && raffleColor }}
                    ticket_type={dataRaffle && dataRaffle.ticket_type}
                  >
                    Ticket:{" "}
                    <strong style={{ fontFamily: "Nunito-Bold", color: dataRaffle && raffleColor }}>{user_ticket <= 0 ? 0 : user_ticket}</strong>
                  </span>
                </TicketWrapper>
              </div>
            </Container>
          </div>
          {this.renderChildrenList()}
          {this.renderRaffleList()}
          {this.renderClosedRaffleList()}
          <AdditionalBottom />
        </div>

        <div className="footer-ticket">
          {/* <div
            className="ticket-wrapper"
            onClick={() => this.toggleModalInfo(true, user_ticket)}
          >
            <KickImage src={raffle_ticket_bg} />
            <span>
              {selectedRaffleGroup.ticket_name} Ticket:{" "}
              <strong>{user_ticket}</strong>
            </span>
          </div> */}
          <div
            className={classNames("submit-ticket-btn", {
              active: readyToRedeem && isTicketEnough,
            })}
            onClick={() =>
              readyToRedeem && isTicketEnough ? this.doSubmitRedeem() : null
            }
            style={
              sectionTitle === "GOOD DAY RAFFLE"
                ? {
                  backgroundColor:
                    sumOfTicket === 0 || !isTicketEnough
                      ? "grey"
                      : raffleColor,
                }
                : {
                  backgroundColor:
                    sumOfTicket === 0 || !isTicketEnough
                      ? "grey"
                      : raffleColor,
                }
            }
          >
            <p>
              Submit {sumOfTicket} Ticket{sumOfTicket !== 1 ? "s" : ""}
            </p>
          </div>
        </div>
      </Container>
    );
  }
}

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0px 50px 0px;
  .info-wrapper {
    display: flex;
    flex-direction: row;
    img {
      width: 20px;
      height: 20px;
      margin-left: 5px;
      cursor: pointer;
    }
    span {
      font-size: 1rem;
      font-family: "Nunito Light";
      color: #074cba;
      text-decoration: underline;
      cursor: pointer;
      text-align: left;
    }
  }
  span {
    font-size: 20px;
    color: #4a4a4a;
    font-family: "Nunito Bold";
    text-align: left;
    &:nth-child(2) {
      font-size: 1rem;
      font-family: "Nunito Light";
      margin-top: 10px;
    }
    strong {
      font-family: "Nunito Bold";
    }
  }

  @media (max-width: 480px) {
    margin-bottom: 0;
    .info-wrapper {
      img {
        width: 15px;
        height: 15px;
      }
      span {
        font-size: 12px;
      }
    }
    span {
      font-size: 12px;
      &:nth-child(2),
      &:last-child {
        font-size: 10px;
      }
    }
  }
`;

const TicketWrapper = styled.div`
  width: 110px;
  height: 30px;
  object-fit: contain;
  border-radius: 21px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "green")};
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: end;
  span {
    font-size: 1rem;
    letter-spacing: 0.5px;
    color: #fff;
    strong {
      font-family: "Nunito Bold";
    }
  }

  @media (max-width: 480px) {
    width: 120px;
    height: 30px;
    align-self: center;
    span {
      font-size: 10px;
    }
  }
`;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }
  span {
    text-align: center;
    font-size: 12px;
    margin-top: 10px;
    font-family: "Nunito-Light";
    .bold {
      font-family: "Nunito-Bold";
    }
  }
  span.bold {
    font-family: "Nunito-Bold";
  }
`;

const AdditionalBottom = styled.div`
  height: 70px;
  @media (max-width: 480px) {
    height: 80px;
  }
`;

const mapStateToProps = (state) => ({
  dataAuth: state.dataAuth,
  raffleGroup: state.dataKaFair.raffleGroup,
  raffle: state.dataKaFair.raffle,
  raffleList: state.dataKaFair.raffleList,
  raffleProduct: state.dataKaFair.raffleProducts,
  totalEntry: state.dataKaFair.totalEntry,
  userRaffleTicket: state.dataKaFair.userRaffleTicket,
  redeemRaffle: state.dataKaFair.redeemRaffle,
  sliderImages: state.sliderHome,
  dataCategory: state.dataCategory.selected,
  countdown_modal: state.dataMenu.countdown_modal,
});

const mapDispatchToProps = (dispatch) => ({
  getRaffleList: (group_name, date) =>
    dispatch(getRaffleList(group_name, date)),
  getClosedRaffleList: (group_name) =>
    dispatch(getClosedRaffleList(group_name)),
  getProductRaffleCount: (raffle_id, ticket_type) =>
    dispatch(getProductRaffleCount(raffle_id, ticket_type)),
  getRafflesToday: (group_name) => dispatch(getRafflesToday(group_name)),
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  postRaffleEntry: (raffles) => dispatch(postRaffleEntry(raffles)),
  getRaffleGroup: () => dispatch(getRaffleGroup()),
  getRaffleBanner: (slug, name, category) =>
    dispatch(getRaffleBanner(slug, name, category)),
  getProductRaffleEntry: (raffle_id, ticket_type) =>
    dispatch(getProductRaffleEntry(raffle_id, ticket_type)),
  getDetailSection: (category, type) => dispatch(getDetailSection(category, type)),
  getCurrencyRate: (country) => dispatch(doFetchCurrencyRate(country)),
  fetchProfile: () => dispatch(doFetchProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RaffleDetailNovembazar));
